import { render, staticRenderFns } from "./ExaminePerson.vue?vue&type=template&id=31e9c4d0&scoped=true"
import script from "./ExaminePerson.vue?vue&type=script&lang=js"
export * from "./ExaminePerson.vue?vue&type=script&lang=js"
import style0 from "./ExaminePerson.vue?vue&type=style&index=0&id=31e9c4d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e9c4d0",
  null
  
)

export default component.exports